module.exports = __webpack_public_path__ + "static/media/slim-white.92a53921.svg";